import React from 'react';

import {
    Wrapper,
    Image,
    MainContent,
    Heading,
    Preamble,
    ReasonToJoin,
    RegAndLoginButton,
    ButtonsWrapper
} from './RegistrationAndLogin.styles';
import { redirect } from 'shared/helpers/redirect';
import homepageTranslations from 'public/locales/en/homepage.json';
import regAndSignInSvg from 'public/assets/homepage/reg-and-signin.svg';
import { getTranslator } from '../../../shared/i18n/getTranslator';
import { MAIN_SITE_LINK } from '../../../constants';

const t = getTranslator(homepageTranslations.registration);

const headlineText = t('headline');
const preambleText = t('join_zoopla.preamble');
const saveFavouritesText = t('join_zoopla.save_favourites');
const setupAlertsText = t('join_zoopla.setup_alerts');
const guidesText = t('join_zoopla.guides');
const registrationButtonText = t('registration_button');
const signInButtonText = t('sign_in_button');

export const RegistrationAndLogin = () => {
    const handleClickRegister = () => {
        redirect(`${MAIN_SITE_LINK}/register`);
    };

    const handleClickSignIn = () => {
        redirect(`${MAIN_SITE_LINK}/signin`);
    };

    return (
        <Wrapper data-testid="registration_and_login">
            <Image src={regAndSignInSvg} alt="" />
            <MainContent>
                <Heading size="6">{headlineText}</Heading>
                <Preamble>{preambleText}</Preamble>
                <ReasonToJoin>{saveFavouritesText}</ReasonToJoin>
                <ReasonToJoin>{setupAlertsText}</ReasonToJoin>
                <ReasonToJoin>{guidesText}</ReasonToJoin>
                <ButtonsWrapper>
                    <RegAndLoginButton
                        variant="primary"
                        onClick={handleClickRegister}
                    >
                        {registrationButtonText}
                    </RegAndLoginButton>
                    <RegAndLoginButton
                        variant="secondary"
                        onClick={handleClickSignIn}
                    >
                        {signInButtonText}
                    </RegAndLoginButton>
                </ButtonsWrapper>
            </MainContent>
        </Wrapper>
    );
};
